import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthorizedRoute from "../../components/routes/AuthorizedRoute";
import UnauthorizedOnlyRoute from "../../components/routes/UnauthorizedOnlyRoute";
import DashboardLayout from "../../layouts/Dashboard";
import BasicLayout from "../../layouts/Basic";
import Page404 from "../../pages/Page404";
import appRoutes, { auth as authRoutes } from "../index";
import { buildChildRoutes } from "../buildChildRoutes";

const authPaths = authRoutes.map((route) => route.path);
const appPaths = appRoutes.map((route) => route.path);

const switchAppRoutes = buildChildRoutes(appRoutes);
const switchAuthRoutes = buildChildRoutes(authRoutes, true);

const MainSwitch = () => (
  <Switch>
    <UnauthorizedOnlyRoute
      path={authPaths}
      render={() => (
        <BasicLayout>
          <Switch>{switchAuthRoutes}</Switch>
        </BasicLayout>
      )}
    />
    <AuthorizedRoute
      path={appPaths}
      render={() => (
        <DashboardLayout key="layout">
          <Switch>
            {switchAppRoutes}
            <Route component={Page404} />
          </Switch>
        </DashboardLayout>
      )}
    />
  </Switch>
);

export default MainSwitch;
